module.exports = __webpack_public_path__ + "static/img/img-logo.f296f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-logo.png
// module id = gnzG
// module chunks = 2